(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-template"]) return;
  try {
    

  /*
    RPECK 25/08/2025 - Filters Select
    Allows us to ensure we're able to add as many filters as required
  */
  document.querySelectorAll('.filters-toolbar__input')?.forEach(function(e) {
    e.addEventListener('change', function(event){
      if(event.target.classList.contains('filters-toolbar__input')) {
        if(!['FilterTags', 'sort_by'].includes(event.target.name)) {
          var url = new URL(window.location);
          event.target.value ? url.searchParams.set(event.target.name, event.target.value) : url.searchParams.delete(event.target.name);
          window.location = url.toString();
        }
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    

  // RPECK 28/08/2025 - Thumbs Swiper
  // Style the thumbs swiper so we are able to get it working with the main one (needs to be invoked first)
  let productThumbSlider = new Swiper('.product-thumbs', {
    slidesPerView: "auto",
    spaceBetween: 7,
    freeMode: true,
    watchSlidesProgress: true,
    centredSlides: true
  });

  // RPECK 28/08/2025 - Main Swiper
  // Go through any Swiper elements on the page and initialize them
  let productMainSlider = new Swiper('.product-main', {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    centredSlides: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: productThumbSlider
    }
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-new"] && !Shopify.designMode) return;
  try {
    
// Hero slider
$(document).ready(function(){
  let slideImages = $('.hero-slide');
  let current = 0;
  let interval = setInterval(function(){
    nextSlide();
  },5000);


  $('#sliderContainer').on('mouseenter', function(){
    clearInterval(interval);
  });


  // Clear All Images
  function reset(){
    for(let i = 0; i < slideImages.length; i++){
      slideImages[i].classList.remove('slide-active');
    }
  }

  function startSlide(){
    reset();
    slideImages[0].classList.add('slide-active');
    $('#slideCurrent').text(current + 1);
  }

  // Show Prev
  function slideLeft(){
    reset();
    slideImages[current - 1].classList.add('slide-active');
    current--;
  }

  // Left Arrow Click
  $('#prev').on('click', function(){
    if(current === 0){
      current=slideImages.length;
    }
    slideLeft()
    $('#slideCurrent').text(current + 1);
  })

  // Show Next
  function slideRight(){
      reset();
      slideImages[current + 1].classList.add('slide-active');
      current++;
  }

  function nextSlide(){
    if(current === slideImages.length -1){
      current=-1;
    }
    slideRight()
    $('#slideCurrent').text(current +1);
  }

  //Right Arrow Click
  $('#next').on('click', function(){
    nextSlide();
  })

  // Insert Total Slides
  $('#slideTotal').text(slideImages.length);

  startSlide();
});

  } catch(e) { console.error(e); }
})();
})();
